module.exports = __webpack_public_path__ + "static/chargebee-slider-6616b898d44e89cfc45149f5054e8109.png";